import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommissionBonusSchedulePort } from "../../../app/ports/integration/commission-bonus-schedule.port";
import { CommissionBonusScheduleResponse } from "../../../domain/models/integration/commission-bonus-schedule.model";
import { EnvMicroIntegration } from "../../config/env.micro.integration";
import { INTEGRATION_ENV } from "../../config/micros-env.tokens";
import { isCommissionBonusScheduleResponse } from "../../validators/integration/commission-bonus-schedule.validator";

@Injectable()
export class CommissionBonusScheduleHttpAdapter implements CommissionBonusSchedulePort {
  private static readonly PATH = "/api/v1/commission-payables/bonus-schedule";

  constructor(private readonly http: HttpClient, @Inject(INTEGRATION_ENV) private readonly env: EnvMicroIntegration) {}

  getSchedule(periodId: number, paidStatus: 0 | 1, typeBonus?: number): Observable<CommissionBonusScheduleResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    let params = new HttpParams().set("periodIds", periodId).set("paidStatus", paidStatus);
    if (typeBonus !== undefined && typeBonus !== null) params = params.set("typeBonus", typeBonus);
    return this.http.get<unknown>(`${baseUrl}${CommissionBonusScheduleHttpAdapter.PATH}`, { params }).pipe(map((response) => {
      if (!isCommissionBonusScheduleResponse(response)) throw new Error("La respuesta del resumen de comisiones es inválida.");
      return response;
    }));
  }
}
